exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".auth_select_55vh {width: 55vh;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/pf.main/authorityselect/authorityselect.component.css
// module id = ../../../../../src/app/pf.main/authorityselect/authorityselect.component.css
// module chunks = main